import { Pipe, PipeTransform } from '@angular/core';
import { SubmissionState } from '@ca/core/models';

@Pipe({ name: 'moduleSubmissionStateTranslationKey' })
export class ModuleSubmissionStateTranslationKeyPipe implements PipeTransform {
    transform(state: SubmissionState): string {
        switch (state) {
            case SubmissionState.approved:
                return 'MODULES.SUBMISSION_STATE.APPROVED';
            case SubmissionState.inReview:
                return 'MODULES.SUBMISSION_STATE.IN_REVIEW';
            case SubmissionState.rejected:
                return 'MODULES.SUBMISSION_STATE.REJECTED';
            case SubmissionState.unpublished:
                return 'MODULES.SUBMISSION_STATE.UNPUBLISHED';
            default:
                return 'MODULES.SUBMISSION_STATE.UNKNOWN';
        }
    }
}
